import { PlaybackHistogram } from '../analytics';
import { IContent, IPlaybackStats, IPlayerSettings, TimeSpan } from './models';

export class PlaybackSessionState {

    id: string;
    playerId: string;

    started: boolean = false;
    content: IContent = null;
    currentPosition: number = 0;
    currentSegment: TimeSpan;

    playbackHistogram: PlaybackHistogram;

    playerSettings: IPlayerSettings;
    playedSegments: TimeSpan[] = [];

    duration: number = 0;

    timeToFirstFrame: number = 0;
    totalPausedTime: number = 0;
    totalPlaybackTime: number = 0;
    totalBufferingTime: number = 0;
    bufferEvents: number = 0;

    completed: boolean;
    playbackStats: IPlaybackStats;

    percentiles: number[] = [];

    getSegments(): TimeSpan[] {
        const segments: TimeSpan[] = [...this.playedSegments];
        if (this.currentSegment) {
            segments.push(this.currentSegment);
        }
        return segments;
    }
}
